import { Checkbox, TableCell, TableHead, TableRow, TableSortLabel } from '@mui/material';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { SortDirection } from '../../utils/constants';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import IF from './IF';

const SortableTableHead = ({
  sortDirection,
  sortBy,
  onRequestSort,
  columns,
  customColumn,
  handleSelectAllClick,
  showCheckbox = false,
  numSelected = 0,
  rowCount = 0,
}) => {
  const uniqueId = new Date().getMilliseconds();
  const { t } = useTranslation();

  const createSortHandler = (property) => () => {
    if (onRequestSort) {
      const isAsc = sortBy === property && sortDirection === SortDirection.Asc;
      onRequestSort({
        sortBy: property,
        sortOrder: isAsc ? SortDirection.Desc : SortDirection.Asc,
      });
    }
  };

  return (
    <TableHead>
      <TableRow>
        {(rowCount > 0 && showCheckbox) && (
        <TableCell
          padding="checkbox"
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
          }}
        >
          <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={handleSelectAllClick}
            inputProps={{
              'aria-label': 'select all',
            }}
          />
        </TableCell>
        )}
        {columns.map((col) => {
          const sortField = col.SortField ?? col.ColField;
          if (customColumn && customColumn.key === col.ColField) {
            return (
              <Fragment key={col.ColField}>
                {customColumn.renderer}
              </Fragment>
            );
          }

          return (
            <TableCell
              key={`${uniqueId}-col-${sortField}`}
              padding={col.disablePadding ? 'none' : 'normal'}
              sortDirection={sortBy === sortField ? sortDirection : false}
              sx={{
                whiteSpace: 'nowrap',
                width: col?.width,
                position: 'sticky',
                top: 0,
                zIndex: 2,
              }}
            >
              {col.Orderable && (
                <TableSortLabel
                  active={sortBy === sortField}
                  direction={sortBy === sortField ? sortDirection : SortDirection.Asc}
                  onClick={createSortHandler(sortField)}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  {t(`Column_${col.ColName}`, t(col.ColName))}
                  <IF condition={sortBy !== sortField}>
                    <UnfoldMoreIcon sx={{ ml: 0.5 }} fontSize="small" color="disabled" />
                  </IF>
                </TableSortLabel>
              )}

              {!col.Orderable && t(`Column_${col.ColName}`, t(col.ColName))}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
};

export default SortableTableHead;
